import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSlideData } from '@context/slide-data';
import { ScriptHeader } from './styles';
import { Line } from '@slides/styles';

export const SummaryScript = () => {
    const { t } = useTranslation();
    const { slideState, data } = useSlideData();
    const { id, details } = data;
    const selectedTerm = slideState.selectedTerm[id];
    const {currentSituation, proposedSituations } = details;
    const termObject = proposedSituations[selectedTerm];
    const { proposedTerms, savings } = termObject;
    const { timeToPayOff } = proposedTerms;
 
    return (
        <>
            <ScriptHeader>
               {t('summary.script.title')}
            </ScriptHeader>
            <Line />
            <div>
                <p><strong> {t('summary.script.0')}</strong></p>
                {t('summary.script.1')}
                <strong style={{ textDecoration: 'underline'}}>{currentSituation.monthlyPayments}</strong>
                {t('summary.script.2')}
                <strong style={{ textDecoration: 'underline'}}>{currentSituation.timeToPayOff}</strong>
                {t('summary.script.3')}
                <strong style={{ textDecoration: 'underline'}}>{currentSituation.totalPayment}.</strong>
             </div>
             <div>
                <p><strong> {t('summary.script.4')}</strong></p>
                {t('summary.script.5')}
                    <strong style={{ textDecoration: 'underline'}}>{proposedTerms.newMonthlyPayment}</strong>
                    {t('summary.script.6')}
                    <strong style={{ textDecoration: 'underline'}}>{timeToPayOff}</strong>
                    {t('summary.script.7')}
                    <strong style={{ textDecoration: 'underline'}}>{proposedTerms.totalPayment}.</strong>
             </div>
             <div>
                    <p><strong>{t('summary.script.8')}</strong></p>
                    {t('summary.script.9')}
                    <strong style={{ textDecoration: 'underline'}}>{savings.monthlySavings}</strong>
                    {t('summary.script.10')}
                    <strong style={{ textDecoration: 'underline'}}>{savings.savingsInYears}</strong>
                    {t('summary.script.11')}
                    <strong style={{ textDecoration: 'underline'}}>{savings.totalSavings}</strong>
                    {t('summary.script.12')}
                    <strong> {t('summary.script.13')}</strong>
             </div>
             <p>{t('summary.script.14')}</p>
        </>
    );
};

export default SummaryScript;
